import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LabelValueType } from '../components/AsyncFormSelect/AsyncFormSelect';

export interface UserTransactionsState {
    transactionTypes: LabelValueType[];
}

const initialState: UserTransactionsState = {
  transactionTypes: [],
};

export const userTransactionsSlice = createSlice({
  name: 'userTransactions',
  initialState,
  reducers: {
    setTransactionTypes: (
      state: UserTransactionsState,
      action: PayloadAction<LabelValueType[]>,
    ) => {
      state.transactionTypes = action.payload;
    },
  },
});

export const {
  setTransactionTypes,
} = userTransactionsSlice.actions;

export default userTransactionsSlice.reducer;
